import "./App.css";
import myroutes from "./datas/routes/routes";
import { useRoutes } from "react-router-dom";
import Topbar from "./components/Topbar/Topbar";
import Sidebar from "./components/Topbar/sidebar/Sidebar";
import { useMediaQuery } from "react-responsive";
import { useState, useContext } from "react";
import { CSSTransition } from "react-transition-group";

import AuthContext from "./contexts/Islogin";
import LoginForm from "./pages/tronvault/LoginForm";
import { Button } from "@mui/material";

// ✅ Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  let router = useRoutes(myroutes);
  const isDesktop = useMediaQuery({ minWidth: 768 });

  const { isLogin, logout } = useContext(AuthContext);
  const [hamburgerSidebar, setHamburgerSidebar] = useState(false);

  const HamburgerSidebar = () => {
    setHamburgerSidebar(!hamburgerSidebar);
  };

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} />
      {isLogin ? (
        <div style={{ height: "100vh", overflow: "hidden" }}>
          <Topbar setHamburgerSidebar={HamburgerSidebar} />

          {/* Logout button */}
  
          <div>


          </div>

          <div className="app-container">
            {isDesktop && !hamburgerSidebar && <Sidebar />}
            <CSSTransition
              in={hamburgerSidebar}
              timeout={900}
              classNames="sidebar"
              unmountOnExit
            >
              <Sidebar />
            </CSSTransition>
            {router}
          </div>
        </div>
      ) : (
        <LoginForm />
      )}
    </>
  );
}

export default App;
